document.querySelectorAll('.ModalMobileMenu').forEach((modal) => {
    const className = 'ModalMobileMenu__trigger--active';
    const list = document.querySelectorAll('.ModalMobileMenu__trigger');

    list.forEach((el) => {
        el.addEventListener('click', () => {
            closeAll(el);
            el.classList.toggle(className);
        })
        const listEl = el.nextElementSibling;
        listEl.style.setProperty('--count', listEl.childElementCount.toString());
    });

    function closeAll(noClose) {
        list.forEach((el) => {
            if(el !== noClose) {
                el.classList.remove(className);
            }
        });
    }
})
